<template>
    <section class="border-t border-green-600 bg-dark-950 dark:bg-gray-800">
        <UContainer class="items-center">
            <UFooterColumns :links="links">
                <template #left>
                    <NuxtLink to="/" class="flex items-center">
                        <NuxtImg width="220px" src="/assets/images/logo-light.webp" :alt="config.public.company.name" />
                    </NuxtLink>

                    <p class="mt-5 leading-normal text-gray-200 lg:mr-6">
                        {{ config.public.company.name }} are a company dedicated to producing the world’s best quality sustainable agarwood using
                        permaculture principles. We are a Hong Kong-based agarwood plantation management company with ownership of permaculture
                        agarwood plantations in Thailand that gives you an opportunity to be a part of this lucrative and sustainable commodity.
                    </p>
                </template>
            </UFooterColumns>

            <UFooter>
                <template #left>{{ copyright }}</template>

                <template #center>
                    <div class="flex gap-x-2">
                        <PagesSocialMedia size="xs" color="white" class="text-white" hover="text-success-600" />
                    </div>
                </template>

                <template #right>
                    <NuxtLink to="/legal/terms-of-use" class="text-white hover:text-success-600">Terms of Use</NuxtLink>

                    <span class="mx-2">|</span>

                    <NuxtLink to="/legal/privacy-policy" class="text-white hover:text-success-600">Privacy Policy</NuxtLink>

                    <span class="mx-2">|</span>

                    <NuxtLink to="/legal/cookie-policy" class="text-white hover:text-success-600">Cookie Policy</NuxtLink>

                    <span class="mx-2">|</span>

                    <NuxtLink to="/legal/disclaimer" class="text-white hover:text-success-600">Disclaimer</NuxtLink>
                </template>
            </UFooter>
        </UContainer>
    </section>
</template>

<script setup>
    const config = useRuntimeConfig()

    const links = [
        {
            label: 'Plantations',
            children: [
                {
                    label: 'Agarwood Plantations',
                    to: '/plantations/agarwood-plantations'
                },
                {
                    label: 'Plantation Challenges',
                    to: '/plantations/plantation-challenges'
                },
                {
                    label: 'Professional Management',
                    to: '/plantations/professional-management'
                },
                {
                    label: 'Carbon Neutral Agriculture',
                    to: '/plantations/carbon-neutral-agriculture'
                }
            ]
        },
        {
            label: 'Sustainability',
            children: [
                {
                    label: 'Agriculture Asset Class',
                    to: '/sustainability/agriculture-asset-class'
                },
                {
                    label: 'Regenerative Practices',
                    to: '/sustainability/regenerative-practices'
                },
                {
                    label: 'Sustainable Future',
                    to: '/sustainability/sustainable-future'
                },
                {
                    label: 'Global Warming Initiative',
                    to: '/sustainability/global-warming-initiative'
                }
            ]
        },
        {
            label: 'Corporate',
            children: [
                {
                    label: 'Book a Discovery Call',
                    to: '/corporate/book-a-discovery-call'
                },
                {
                    label: 'Core Values',
                    to: '/corporate/core-values'
                },
                {
                    label: 'Meet the Team',
                    to: '/corporate/meet-the-team'
                },
                {
                    label: 'Careers',
                    to: '/corporate/careers'
                },
                {
                    label: 'Investor Relations',
                    to: '/corporate/investor-relations'
                },
                {
                    label: 'Contact Us',
                    to: '/corporate/contact-us'
                }
            ]
        },
        {
            label: 'Ethics',
            children: [
                {
                    label: 'Code of Ethics',
                    to: '/legal/code-of-ethics'
                },
                {
                    label: 'Sustainability Policy',
                    to: '/legal/sustainability-policy'
                },
                {
                    label: 'Anti-Deforestation Policy',
                    to: '/legal/anti-deforestation-policy'
                },
                {
                    label: 'Anti-Slavery Policy',
                    to: '/legal/anti-slavery-policy'
                }
            ]
        }
    ]

    const copyright = computed(() => {
        return `© ${new Date().getFullYear()} ${config.public.company.legal.name}. Registration Number ${config.public.company.legal.number}. All Rights Reserved`
    })
</script>
